import * as types from '../actions/types';

const initialState = {
  previousImports: [],
  fetchingPreviousImports: false,
  previousImportsError: null,
  customFields: [],
  fetchingCustomFields: false,
  customFieldsError: null
};

export default function holderSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_FETCHING_PREVIOUS_IMPORTS:
      return { ...state, fetchingPreviousImports: action.payload };

    case types.SET_PREVIOUS_IMPORTS:
      return {
        ...state,
        previousImports: Array.isArray(action.payload) ? action.payload : [],
        previousImportsError: null
      };

    case types.SET_PREVIOUS_IMPORTS_ERROR:
      return { ...state, previousImportsError: action.payload };

    case types.SET_FETCHING_CUSTOM_FIELDS:
      return { ...state, fetchingCustomFields: action.payload };

    case types.SET_CUSTOM_FIELDS_FOR_IMPORT:
      return {
        ...state,
        customFields: Array.isArray(action.payload) ? action.payload : [],
        customFieldsError: null
      };

    case types.SET_CUSTOM_FIELDS_FOR_IMPORT_ERROR:
      return { ...state, customFieldsError: action.payload };

    default:
      return state;
  }
}